export const getLocalSelectedDevice = () => {
  const selectedDevice = localStorage.getItem('DEVICE_NAME');
  return JSON.parse(selectedDevice)
};

export const setLocalSelectedDevice = (newDevice) => {
  localStorage.setItem('DEVICE_NAME', JSON.stringify(newDevice))
};